import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";

const HireMe = () => {
  const form = useRef();
  const [submitted, setSubmitted] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_8s0bm3b",  
        "template_z2aibg8", 
        form.current,
        "LINz_46njDLx1aWcD" 
      )
      .then(
        () => {
          setSubmitted(true); 
        },
        () => {
          alert("❌ Failed to send message. Please try again!");
        }
      );
  };

   return (
    <div className="min-h-screen flex items-center justify-center pt-5 pb-10 px-5 md:px-4">
      <div className="bg-blue-100 shadow-2xl rounded-[50px] md:rounded-2xl p-8 w-full  max-w-xl text-center ">
        {/* <h1 className="text-4xl font-[anzo] text-blue-900 mb-6">Hire Me</h1> */}

        {submitted ? (
          <div className="flex flex-col items-center justify-center py-10 bg-blue-200">
            <h2 className="text-3xl font-semibold text-black mb-4">
              Thank you!
            </h2>
            <p className="text-lg text-gray-700">
              Your details have been sent successfully. I’ll get back to you soon.
            </p>
          </div>
        ) : (
          // Form
          
          <form ref={form} onSubmit={sendEmail} className="flex flex-col gap-4">
            <h1 className="text-5xl font-[anzo] text-blue-900 mb-6">Hire Me</h1>
            <div className="flex flex-col text-left">
              <label className="text-sm font-semibold text-blue-900 mb-1">
                Full Name
              </label>
              <input
                type="text"
                name="user_name"
                required
                pattern="^[A-Za-z\s]+$"
                title="Name should contain only letters"
                className="border border-gray-300 rounded-lg p-1 text-xl focus:outline-none focus:ring-2 focus:ring-blue-300"
              />
            </div>

            {/* Email */}
            <div className="flex flex-col text-left">
              <label className="text-sm font-semibold text-blue-900 mb-1">
                Email Address
              </label>
              <input
                type="email"
                name="user_email"
                required
                className="border border-gray-300 rounded-lg p-1 text-xl focus:outline-none focus:ring-2 focus:ring-blue-300"
              />
            </div>

            {/* Company */}
            <div className="flex flex-col text-left">
              <label className="text-sm font-semibold text-blue-900 mb-1">
                Company Name
              </label>
              <input
                type="text"
                name="company"
                required
                className="border border-gray-300 rounded-lg p-1 text-xl focus:outline-none focus:ring-2 focus:ring-blue-300"
              />
            </div>

            {/* Purpose */}
            <div className="flex flex-col text-left">
              <label className="text-sm font-semibold text-blue-900 mb-1">
                Purpose of Contact
              </label>
              <input
                type="text"
                name="purpose"
                required
                className="border border-gray-300 rounded-lg p-1 text-xl focus:outline-none focus:ring-2 focus:ring-blue-300"
              />
            </div>

            {/* Message */}
            <div className="flex flex-col text-left">
              <label className="text-sm font-semibold text-blue-900 mb-1">
                Message
              </label>
              <textarea
                name="message"
                rows="3"
                required
                minLength="10"
                className="border border-gray-300 rounded-lg p-1 text-xl focus:outline-none focus:ring-2 focus:ring-blue-300"
              />
            </div>

            <button
              type="submit"
              className="bg-blue-900 text-white/90 text-lg font-semibold py-1 md:py-3 rounded-lg hover:bg-blue-800 transition"
            >
              Send Message
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default HireMe;
